import { render, staticRenderFns } from "./ConsignmentSpecialServices.vue?vue&type=template&id=6e39780d&scoped=true"
import script from "./ConsignmentSpecialServices.vue?vue&type=script&lang=js"
export * from "./ConsignmentSpecialServices.vue?vue&type=script&lang=js"
import style0 from "./ConsignmentSpecialServices.vue?vue&type=style&index=0&id=6e39780d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e39780d",
  null
  
)

export default component.exports